import Glide, { Controls } from '@glidejs/glide/dist/glide.modular.esm';
import { mqMediumLarge } from '../utils/matchMedia';

const glider = () => {
  let gliders;
  let mqFlag = false;
  let winWidth = window.innerWidth;
  let peekAmount = mqMediumLarge.matches ? 0 : 100;

  Array.prototype.slice.call(document.querySelectorAll('.glide')).forEach(function (glide) {

    // setup
    const settings = {
      type: 'carousel',
      animationDuration: 1000,
      animationTimingFunc: 'ease-in-out',
      autoplay: false,
      perView: 1,
      gap: 0,
      peek: peekAmount
    }
    const carousel = new Glide(glide, settings);
    gliders = carousel;
    const prev = glide.querySelector('.glide__arrow--left');
    const next = glide.querySelector('.glide__arrow--right');
    let indexes;

    setTimeout(() => {
      // wait till next tick to get all
      // slides (clones included)
      indexes = document.querySelectorAll('.glide__slide');

      // filter out cloned slides
      indexes = [...indexes].filter(slide => {
        if (!slide.classList.contains('glide__slide--clone')) {
          return slide
        }
      });


      // dont peek if there's only 1 item
      if (indexes.length <= 1) {
        carousel.update({ peek: 0 });
        prev.style.display = 'none';
        next.style.display = 'none';
      } else {
        prev.style.opacity = 1;
        next.style.opacity = 1;
      }
    }, 0);


    const beforeAnimating = (dir) => {
      let current;

      carousel.on('run.before', function () {
        let slidez = document.querySelectorAll('.glide__slide');
        let activeSlide = document.querySelector('.glide__slide--active');

        // set prev img scale(1) so does not immediately go to scale(.85)
        activeSlide.previousElementSibling.querySelector('.glide__img').style.transform = "scale(1)";
        // ^ still an issue with the 'cloned' image jumping directly to scale(.85)

        setTimeout(() => {

          // get active and remove class
          current = glide.querySelector('.glide__slide--active');
          if (current) {
            current.classList.remove('glide__slide--active');
          }

          // add active before animation starts
          indexes[carousel.index].classList.add('glide__slide--active');

          if (dir === 'next') {
            if (activeSlide.nextElementSibling.classList.contains('glide__slide--clone')) {
              activeSlide.nextElementSibling.classList.add('glide__slide--active');
            }
          } else {
            if (activeSlide.previousElementSibling.classList.contains('glide__slide--clone')) {
              activeSlide.previousElementSibling.classList.add('glide__slide--active');
            }
          }
        }, 0);
      });
    }

    const nextSlide = () => {
      beforeAnimating('next');
    }
    const prevSlide = () => {
      beforeAnimating('prev');
    }
    next.addEventListener('click', nextSlide, {once : true});
    prev.addEventListener('click', prevSlide, {once : true});

    carousel.mount({ Controls });
  });

  window.addEventListener('resize', () => {

    if (winWidth !== window.innerWidth) {
      // remove image peekers
      if (mqMediumLarge.matches && !mqFlag) {
        gliders.update({peek: 0});
        mqFlag = true;
      }

      // add image peekers
      if (!mqMediumLarge.matches && mqFlag) {
        gliders.update({peek: peekAmount});
        mqFlag = false;
      }
    }
  });
}

export default glider;